import { styled } from "@mui/material/styles";
import {
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { titleCase } from "change-case-all";
import { tableCellClasses } from "@mui/material/TableCell";

import { colors } from "../../css components/Style";
import { convertDate } from "../../../utils";
import { CgEye } from "react-icons/cg";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.publicisBlue};
  color: ${colors.publicisBlue};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  border-radius: 10px;
  &:hover {
    border: 1px solid ${colors.publicisBlue};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.theme,
    color: colors.text,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  ".MuiTableCell-root": {
    border: "none",
    padding: "10px",
  },

  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function List({
  name,
  agent,
  fields,
  agentInfo,
  setDialogState,
}) {
  return (
    <Paper>
      <Grid size={12}>
        <Typography
          style={{
            padding: "20px 0 10px 10px",
            fontWeight: 600,
            fontSize: "18px",
          }}
          color={colors.publicisBlue}
        >
          <img
            style={{ height: "20px", position: "relative", top: "4px" }}
            src={agentInfo.logo}
            alt="!"
          />{" "}
          {agentInfo.agentName}
        </Typography>
      </Grid>

      <TableContainer
        sx={{ maxHeight: 440, borderRadius: "0 0" }}
        component={Paper}
      >
        <Table
          stickyHeader
          sx={{ minWidth: 700 }}
          aria-label="customized table"
        >
          <TableHead style={{ height: "45px" }}>
            <TableRow>
              {fields?.map((column, index) => (
                <StyledTableCell key={index} style={{ fontWeight: 700 }}>
                  {titleCase(column.name?.replace(/_/g, " "))}
                </StyledTableCell>
              ))}

              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {agent?.map((row, rowIndex) => (
              <StyledTableRow key={rowIndex}>
                {fields?.map((column, colIndex) => (
                  <StyledTableCell component="th" scope="row" key={colIndex}>
                    {row.channel_id === 3 && column.name === "expiry_token"
                      ? convertDate(row[column?.name])
                      : row[column?.name]?.length > 50
                      ? row[column?.name]?.substr(0, 50)
                      : row[column?.name]}
                  </StyledTableCell>
                ))}

                <StyledTableCell>
                  <Tooltip title="View Agent">
                    <Icon
                      onClick={() => {
                        setDialogState({
                          state: true,
                          update: true,
                          key: name,
                          agents: agent,
                          data: row,
                          index: rowIndex,
                        });
                      }}
                    >
                      <CgEye />
                    </Icon>
                  </Tooltip>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
